import type { TranslationsByNamespace } from '@locales/generated';
import type { GetTranslation } from '@shared/core';

type PageData = {
  id: string;
  disabled: boolean;
  type: string;
  pageSlug: string;
};

export const generateDescriptionKeywords = (t: GetTranslation<TranslationsByNamespace['websitePages']>, pageData?: readonly PageData[]) => {
  const { accommodations, travelDetails, registryInformation, eventInformation } = t('seo');
  let hasAccommodations = false;
  let hasTravel = false;
  let hasRegistry = false;

  pageData?.forEach(page => {
    if (!page.disabled) {
      if (page.type === 'custom' && page.pageSlug === 'accommodations') {
        hasAccommodations = true;
      } else if (page.type === 'travel') {
        hasTravel = true;
      } else if (page.type === 'registry') {
        hasRegistry = true;
      }
    }
  });

  const keywords: string[] = [];
  if (hasAccommodations) {
    keywords.push(accommodations());
  } else if (hasTravel) {
    keywords.push(travelDetails());
  }
  if (hasRegistry) {
    keywords.push(registryInformation());
  }
  if (keywords.length === 0) {
    keywords.push(eventInformation());
  }

  return keywords.join(', ');
};
